import BacklightApp from "@/components/BacklightApp";

export default function App() {
  return <BacklightApp />;
}
